export default __webpack_public_path__ + "static/media/sample_installer.44992492.xlsx";